module.exports = __webpack_public_path__ + "img/sprite.symbol.8c5b6005.svg";